module.exports = __webpack_public_path__ + "assets/e646448bfae302e34104c70b30d3e056.png";